import classNames from 'classnames';
import React from 'react';

interface WizardActionsProps {
  currentStep: number;
  totalSteps: number;
  onBack: () => void;
  onContinue: () => void;
  onSubmit: () => void;
  isContinueDisabled: boolean;
  isSubmitDisabled: boolean;
  submitting: boolean;
  continueLabel?: string;
  className?: string;
}

/**
 * Component for wizard navigation buttons (Back, Continue, Submit).
 * Handles button states and labels based on current step position.
 */
export const WizardActions: React.FC<WizardActionsProps> = ({
  currentStep,
  totalSteps,
  onBack,
  onContinue,
  onSubmit,
  isContinueDisabled,
  isSubmitDisabled,
  submitting,
  continueLabel = 'Continue',
  className,
}) => {
  return (
    <div className={classNames('wizard__actions', className)}>
      <button
        type='button'
        className='btn btn-link'
        onClick={onBack}
        disabled={currentStep === 0}
        aria-label={currentStep === 0 ? 'Cannot go back, already on first step' : 'Go to previous step'}
      >
        Back
      </button>

      {currentStep === totalSteps - 1 ? (
        <div className='d-flex flex-column align-items-end'>
          <button
            type='button'
            className='primary'
            onClick={onSubmit}
            disabled={isSubmitDisabled}
            aria-disabled={isSubmitDisabled}
          >
            {submitting ? 'Submitting…' : 'Submit Order'}
          </button>
        </div>
      ) : (
        <button
          type='button'
          className='primary'
          onClick={onContinue}
          disabled={isContinueDisabled}
          aria-label={continueLabel}
        >
          {continueLabel}
        </button>
      )}
    </div>
  );
};
